import {
  InsuredLocationPostRequestBody,
  InsuredLocationPostRequestParams,
  InsuredLocationPostResponse,
} from '@lio/api-types';
import { customerQueryKey } from '@services/customer/keys';
import { useQueryClient, useMutation } from '@tanstack/react-query';
import { useClient } from '@utils/api-client';

export const useCreateInsuredLocation = () => {
  const client = useClient();
  const queryClient = useQueryClient();
  const mutationFn = ({
    customerId,
    label,
    status,
    address,
    isPrimary,
  }: InsuredLocationPostRequestBody & InsuredLocationPostRequestParams) =>
    client
      .post(`customer/${customerId}/insured-location`, {
        json: {
          label,
          status,
          address,
          isPrimary,
        },
      })
      .json<InsuredLocationPostResponse>();
  const result = useMutation({
    mutationFn,
    onSuccess: (data) => {
      queryClient.invalidateQueries({
        queryKey: [...customerQueryKey._customerLocation(data.customerId), 'list'],
      });
      queryClient.invalidateQueries({
        queryKey: [...customerQueryKey._customerBrokerage(data.customerId), 'metadata'],
      });
    },
  });
  return { ...result, createInsuredLocationAsync: result.mutateAsync };
};
